import { IconCheckMarkSolid, Pill } from "@instructure/ui";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { MasteryLevelContext } from "../../utils/Context";
import { Selector } from "./Selector";

const RatingScaleSelect = ({
  title,
  selectHandler,
  size,
  interaction,
  clear,
  masteryMapping,
  outcome,
}) => {
  const { ratingScales } = useContext(MasteryLevelContext);
  const [mappings, setMappings] = useState([]);

  useEffect(() => {
    if (ratingScales) {
      // Deep copy the rating scales to avoid mutating the original data
      let maps = JSON.parse(JSON.stringify(ratingScales));
      maps.forEach((map) => {
        map.label = map.title;
        const scale = outcome?.rating_scales?.find(
          (s) => s.rating_to_mastery_level_map === map.id
        );
        if (scale && scale.is_default) {
          map.renderAfterLabel = (
            <Pill color="success">{t("masteryLevels.default")}</Pill>
          );
        } else if (scale) {
          map.renderAfterLabel = <IconCheckMarkSolid color="success" />;
        }
      });
      let mappingList = maps.filter((map) => map.is_mapped === true);

      setMappings(mappingList);
    }
  }, [ratingScales, outcome]);

  return (
    <Selector
      label={title}
      size={size}
      options={mappings}
      selectHandler={selectHandler}
      selectedItemId={masteryMapping}
      interaction={interaction}
      clear={clear}
    />
  );
};

export default RatingScaleSelect;
